import { Component, OnInit, Inject, EventEmitter, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatTabsModule, MatTabChangeEvent, MatDialogRef, MatTooltipModule } from '@angular/material';
import { MAT_DIALOG_DATA } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { User } from '../user.model';
import { Region } from '../user.model';
import { UserDetailsDialog } from './user-details-dialog.model';
import { Audit } from '../../audits/audit.model';
import { UserService } from '../user.service';
import { AuditService } from '../../audits/audit.service';
import { UserProfileService } from '../../userprofile/userprofile.service';
import { UserProfile } from '../../userprofile/userprofile.model';
import { UserEditComponent } from '../user-edit/user-edit.component';
import { CondoSkillset, UserCondoSkillset } from '../../condoskillsets/condoSkillset.model';
import { CondoSkillsetsService } from '../../condoskillsets/condoskillsets.service';

@Component({
    selector: 'app-user-details',
    templateUrl: './user-details.component.html',
    styleUrls: ['./user-details.component.css']
})


export class UserDetailsComponent implements OnInit {
    public isAdmin = false;
    public userProfile = new UserProfile();
    public userProfileLoading: boolean = false;
    public userProfileLoadError: boolean = false;
    public relatedUsers: User[];
    public regions: Region[];
    public changes: Audit[] = new Array();
    public relatedPersonas: string[] = [];
    public activeTab: string;
    public whiteGlove: string;
    @ViewChild('tg') vcTg: any;
    public hasSpecialties: boolean = false;
    public hasTimeOffs: boolean = false;
    public userCondoSkillsets: UserCondoSkillset[] = [];

    constructor(
        public dialogRef: MatDialogRef<UserDetailsComponent>,
        @Inject(MAT_DIALOG_DATA) public user: User,
        private fb: FormBuilder,
        private userService: UserService,
        private condoSkillsetService: CondoSkillsetsService,
        private auditService: AuditService,
        private userProfileService: UserProfileService,
        private dialog: MatDialog) {
        user.loggedInUserEmail = this.userService.currentUser.email;
    }

    async ngOnInit() {
        this.userProfile.picture = null;
        this.getAudit();
        this.getUserProfile();
        this.findUniqueRelatedPersonas();
        this.checkForTimeOffs();
        this.checkForSpecialties();
        this.getCondoSkillsets();
        this.isAdmin = (this.userService.currentUser.isAdmin) ? this.userService.currentUser.isAdmin : false;
        this.hasSpecialties = (this.user.hasSpecialties);
        this.hasTimeOffs = (this.user.hasTimeOffs);
        this.whiteGlove = this.user.whiteGlove;

        await this.userService.getAssignedRegions(this.user.id).then(
            result => {
                var unfilteredUserRegions = JSON.parse(JSON.stringify(result));
                this.regions = this.updateRegionForProfileType(unfilteredUserRegions);            }
        )
            .catch(error => console.log(error));
    }

    updateRegionForProfileType(unfilteredRegions: Region[]) {
        if (this.user.persona == "Loan Officer") {
            return unfilteredRegions.filter(x => x.group == "Underwriting");
        }
        else {
            return unfilteredRegions.filter(x => x.group == null || x.group == "Closer" || x.group == "Region 15");
        }
    }

    getAudit() {
        this.auditService.getUserChanges(this.user.id)
            .then(resp => {
                this.changes = resp;
            }).catch(error => {
            });
    }

    findUniqueRelatedPersonas() {
        // Get all personas from related users
        const personas: string[] = this.user.relationships.map(data => data.persona);
        // Unique personas
        this.relatedPersonas = personas.filter((x, i, a) => x && a.indexOf(x) === i);
    }

    getUserProfile() {
        this.userProfileLoading = true;
        this.userProfileService.getUserProfile(this.user.email)
            .then(resp => {
                this.userProfile = resp;
                this.userProfileLoading = false;
            })
            .catch(error => {
                this.userProfileLoading = false;
                this.userProfileLoadError = true;
            });
    }

    checkForTimeOffs() {
        if (this.user.timeOffDateRanges.length > 0) {
            this.user.hasTimeOffs = true;
        }
    }

    checkForSpecialties() {
        if (this.user.loanPrograms.length > 0) {
            this.user.hasSpecialties = true;
        }
    }

    deleteUser(user: User) {
        if (confirm('Are you sure you want to delete ' + user.name + '?')) {
            this.userService.deleteUser(user.id, user.loggedInUserEmail)
                .then(success => {
                    if (!success)
                        confirm('There was an error processing your request.');
                    else
                        this.dialogRef.close();
                })
                .catch(error => {
                    confirm('There was an error processing your request.');
                });
        }
    }

    openEditUserDetails(user: User) {
        var userDetailDialog: UserDetailsDialog = {
            user: user,
            activeTab: this.activeTab
        };
        this.dialog.open(UserEditComponent, {
            data: userDetailDialog,
            disableClose: true,
            width: "800px",
            height: "600px"
        });
        this.dialogRef.close();
    }


    onSelectChange(event) {
        this.activeTab = event.tab.textLabel;
    }

    isCapacityEnabledPersona(user: User) {
        return user.persona === "Underwriter" || user.persona === "Collateral UW" || user.persona == "UW 1" || user.persona == 'Condo Underwriter';
    }

    isRelationshipEnabledPersona(user: User) {
        return user.persona !== 'Collateral UW' && user.persona !== 'Condo Underwriter';
    }

    isLoanProgramEnabledPersona(user: User) {
        return user.persona !== 'Collateral UW'
            && user.persona != 'Condo Underwriter'
            && user.persona !== 'Field Sales Manager';
    }

    isNumber(val): boolean { return typeof val === 'number'; }

    ShouldUserHaveRegion(user: User) {
        return user.persona === "Loan Officer" || user.persona === "Sr Closer" || user.persona == "ICD Closer";
    }

    IsUserValidLoanOfficer() {
        return this.user.persona === "Loan Officer";
    }

    getCondoSkillsets() {
        this.condoSkillsetService.getUserCondoSkillsets(this.user.id)
            .then(resp => {
                this.userCondoSkillsets = resp;
            });
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/users/user-details/user-details.component.ts